module.exports = __webpack_public_path__ + "static/media/top-nfts-9.c710b12d.jpg";